// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const navConfig = [
  {
    title: '撮影一覧',
    path: '/dashboard/photography',
    icon: icon('ic_cart'),
  },
  {
    title: 'お客様情報',
    path: '/dashboard/customer',
    icon: icon('ic_user'),
  }
];

export default navConfig;
